import React, { FC } from 'react';
import { Redirect, Route, RouteProps } from 'react-router';

import { store } from 'redux/store';
import { ROUTES } from 'routes';

interface ProtectedRouteProps extends RouteProps {
  forContext: AppContext | AppContext[];
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({
  forContext,
  component: Component,
  children,
  ...restProps
}) => {
  return (
    <Route
      {...restProps}
      render={(routeProps) => {
        const state = store.getState();
        const isAuthorized = state.isAuthorized;
        const accessData = state.getAccess;

        if (!accessData || forContext.indexOf(accessData.context) < 0) {
          return (
            <Redirect
              to={{
                pathname: ROUTES.MESSAGE_PAGE,
                state: {
                  code: '403',
                  message: 'You are not authorized to access this page.',
                },
              }}
            />
          );
        }

        if (!isAuthorized) {
          return <Redirect to={ROUTES.AUTH} />;
        }

        return Component ? <Component {...restProps} {...routeProps} /> : children;
      }}
    />
  );
};

export default ProtectedRoute;
